import router, {resetRouter}  from '@router'
import {defaultRoutes} from '@router/routes'
import {getPermissionRoutes} from '@router/permission'
import store from '@store'
import http from '@/axios'
import {dealCancelToken} from '@/axios/cancel'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


NProgress.configure({ showSpinner: false });// NProgress 配置

/**
 * 路由守卫
 */
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  dealCancelToken();
  // 查询授权状态
  if (store.state.activeStatus === "") {
    let res = await http.checkLicenseVerify();
    if (res?.data) {
      let status = res.data.status;
      let expire_at = res.data.expire_at;
      store.commit("setActiveStatus", {status, expire_at});
    }
  }
  if (to.path === "/verify") {
    next();
  } else if (store.state.activeStatus === false) {
    next("/verify");
  } else if (to.path === "/login") {
    resetRouter();// 重置路由
    sessionStorage.clear();// 清除session
    store.commit("clearData");// 清除vuex的值
    next();
  } else if (!store.state.token) {// 未登录或非白名单跳转登录页面
    to?.meta?.allow ? next() : next("/login");
  } else if (!store.state.permissions) {
    let res = await http.getPermissions(); // 未获得权限时后台查询并生成对应的路由
    if (res) {
      let permissions = res.data.permissions || [];
      let isAdmin = res.data.is_admin;
      store.commit("setPermission", permissions);
      store.commit("setIsAdmin", isAdmin);
      let permissionRoutes = getPermissionRoutes(permissions);
      router.addRoutes([
        ...permissionRoutes,
        ...defaultRoutes,
      ]);
      next({...to, replace: true});
    }
  } else {
    next();
  }
  NProgress.done();
});
